import { createPortal } from 'react-dom'
import { useDispatch } from 'react-redux'
import { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import NodeInputHandler from '../../views/canvas/NodeInputHandler'
import { HIDE_CANVAS_DIALOG, SHOW_CANVAS_DIALOG } from '../../store/actions'
import { AppDispatch } from '@/store'


const AdditionalParamsDialog = ({ show, dialogProps, onCancel }) => {
    const portalElement: any = document.getElementById('portal')
    const dispatch = useDispatch<AppDispatch>()

    const [inputParams, setInputParams] = useState([])
    const [data, setData] = useState({})

    useEffect(() => {
        if (dialogProps.inputParams) setInputParams(dialogProps.inputParams)
        if (dialogProps.data) setData(dialogProps.data)

        return () => {
            setInputParams([])
            setData({})
        }
    }, [dialogProps])

    
    useEffect(() => {
        if (show) {
            dispatch({ type: SHOW_CANVAS_DIALOG })
        } else {
            dispatch({ type: HIDE_CANVAS_DIALOG })
        }
        return () => {
            dispatch({ type: HIDE_CANVAS_DIALOG })
        }
    }, [show, dispatch])


    const component = show ? (
        <div className="absolute top-10 right-0 bottom-0 w-64 bg-white shadow-lg">
        <div className="flex justify-between items-center p-4 border-b">
            <h3 className="text-lg font-semibold">Additional Parameters</h3>
            <button
                className="text-gray-500 hover:text-gray-700"
                onClick={onCancel}
                aria-label="Close"
            >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12"></path>
                </svg>
            </button>
        </div>
        <div className="p-4 h-[calc(100vh-50px)] overflow-y-auto">
            {inputParams.map((inputParam, index) => (
                <NodeInputHandler
                    disabled={dialogProps.disabled}
                    key={index}
                    inputParam={inputParam}
                    data={data}
                    isAdditionalParams={true}
                />
            ))}
        </div>
    </div>
    
    ) : null

    return createPortal(component, portalElement)
}

AdditionalParamsDialog.propTypes = {
    show: PropTypes.bool,
    dialogProps: PropTypes.object,
    onCancel: PropTypes.func
}

export default AdditionalParamsDialog
